import type { ReviewedLibraryIdentity } from './library-identity-types';
import { LIBRARY_CHEST_01 } from './reviewed-chest-identities-01';
import { LIBRARY_CHEST_02 } from './reviewed-chest-identities-02';
import { LIBRARY_BACK_01 } from './reviewed-back-identities-01';
import { LIBRARY_BACK_02 } from './reviewed-back-identities-02';
import { LIBRARY_SHOULDERS_01 } from './reviewed-shoulders-identities-01';
import { LIBRARY_SHOULDERS_02 } from './reviewed-shoulders-identities-02';
import { LIBRARY_ARMS_01 } from './reviewed-arms-identities-01';
import { LIBRARY_ARMS_02 } from './reviewed-arms-identities-02';
import { LIBRARY_LEGS_01 } from './reviewed-legs-identities-01';
import { LIBRARY_LEGS_02 } from './reviewed-legs-identities-02';
import { LIBRARY_ABS_01 } from './reviewed-abs-identities-01';
import { LIBRARY_WARMUP_01 } from './reviewed-warmup-identities-01';
import { LIBRARY_WARMUP_02 } from './reviewed-warmup-identities-02';
import { LIBRARY_WARMUP_03 } from './reviewed-warmup-identities-03';
import { LIBRARY_WARMUP_04 } from './reviewed-warmup-identities-04';
import { LIBRARY_STRETCH_01 } from './reviewed-stretch-identities-01';
import { LIBRARY_STRETCH_02 } from './reviewed-stretch-identities-02';

export const REVIEWED_LIBRARY_IDENTITIES: ReviewedLibraryIdentity[] = [
  ...LIBRARY_CHEST_01,
  ...LIBRARY_CHEST_02,
  ...LIBRARY_BACK_01,
  ...LIBRARY_BACK_02,
  ...LIBRARY_SHOULDERS_01,
  ...LIBRARY_SHOULDERS_02,
  ...LIBRARY_ARMS_01,
  ...LIBRARY_ARMS_02,
  ...LIBRARY_LEGS_01,
  ...LIBRARY_LEGS_02,
  ...LIBRARY_ABS_01,
  ...LIBRARY_WARMUP_01,
  ...LIBRARY_WARMUP_02,
  ...LIBRARY_WARMUP_03,
  ...LIBRARY_WARMUP_04,
  ...LIBRARY_STRETCH_01,
  ...LIBRARY_STRETCH_02,
];
